import { DelayedPaymentComponent } from './delayed-payment.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ DelayedPaymentComponent });
